import { createAsyncThunk } from "@reduxjs/toolkit";
import { DeleteFeatures } from "./featuresTypeSlice";
import { ApiResponse } from "../../../types/APIResponse";
import api, {apiWithFormDataMethods} from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import {Features} from "../../../types";

// Async Thunks
export const fetchFeatures = createAsyncThunk<Features[], void, { rejectValue: string }>(
    'features/fetchFeatures',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get<ApiResponse<Features[]>>(apiEndpoints.features.getAll);
            return response.data; // Access the `data` field containing the categories
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch pricing Plans');
        }
    }
);

export const addFeatures = createAsyncThunk<Features, { name: string, description: string, key: string, translationKey?: string, nameTranslations?: Record<string, string>, descriptionTranslations?: Record<string, string> }, { rejectValue: string }>(
    'features/addFeatures',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post<ApiResponse<Features>>(apiEndpoints.features.create, {data});
            return response.data; // Access the `data` field containing the created category
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to add features');
        }
    }
);

export const updateFeatures = createAsyncThunk<Features, { id: string, name: string, description: string, key: string, translationKey?: string, nameTranslations?: Record<string, string>, descriptionTranslations?: Record<string, string>, isActive?: boolean }, { rejectValue: string }>(
    'features/updateFeatures',
    async ({ id, name, description, key, translationKey, nameTranslations, descriptionTranslations, isActive } , { rejectWithValue }) => {
        try {
            const response = await api.put<ApiResponse<Features>>(`${apiEndpoints.features.update}/${id}`, {data: {name, description, key, translationKey, nameTranslations, descriptionTranslations, isActive}} );
            return response.data; // Access the `data` field containing the updated category
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to update features');
        }
    }
);

export const deleteFeatures = createAsyncThunk<DeleteFeatures, { id: string }, { rejectValue: string }>(
    'features/deleteFeatures',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await api.delete<ApiResponse<DeleteFeatures>>(`${apiEndpoints.features.delete}/${id}`);
            return { ...response.data, id }; // Access the `data` field containing the deleted category
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to delete features');
        }
    }
);

export const updateFeaturesOrder = createAsyncThunk<Features[], { orderUpdates: Array<{ id: string; index: number }> }, { rejectValue: string }>(
    "features/updateFeatures",
    async ({ orderUpdates }, { rejectWithValue }) => {
        try {
            const response = await api.post<ApiResponse<Features[]>>(apiEndpoints.features.updateOrder, { data: { orderUpdates } });
            if (response?.success) {
                return response.data;
            } else {
                throw new Error(response.message || "Failed to update features order");
            }
        } catch (error: any) {
            return rejectWithValue(error.message || "Failed to update features order");
        }
    }
);
